import React, { useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import ReCAPTCHA from 'react-google-recaptcha'


const urlAgregar = 'https://datosprofes.cpem46.edu.ar/Backendphp/agregar_docente.php'

const AgregarDocente = () => {
    const [apellido, setApellido] = useState('')
    const [nombre, setNombre] = useState('')
    const [dni, setDni] = useState('')
    const [email, setEmail] = useState('')
    const [titulo, setTitulo] = useState('')
    const [fechaNac, setFechaNac] = useState('')
    const [domicilio, setDomicilio] = useState('')
    const [telefono, setTelefono] = useState('')
    
    const [nempleado, setNempleado] = useState('')

    const [captchaToken, setCaptchaToken] = useState('')

    const guardarDocente = (e) => {
        e.preventDefault()

        if (!captchaToken) {
            Swal.fire({
                title: 'Captcha requerido',
                text: 'Por favor completá el captcha',
                icon: 'warning',
            })
            return
        }
        
        const nuevoDocente = {
        apellido: capitalizar(apellido),
        nombre: capitalizar(nombre),
        dni,
        nempleado,
        correo: email.toLowerCase(),
        titulo: capitalizar(titulo),
        fecha_nac: fechaNac,
        domicilio: capitalizar(domicilio),
        telefono,
        recaptchaToken: captchaToken,
        }


        axios.post(urlAgregar, nuevoDocente)
        .then((res) => {
            const { success, message } = res.data

            if(success){
                Swal.fire({
                title: 'Éxito',
                text: 'REGISTRO EXITOSO',
                icon: 'success'
            }).then(() => {
                window.location.href = 'https://cpem46.edu.ar';
                resetFormulario()
                })
            }else{
                Swal.fire({
                    title: 'Error',
                    text: 'Ya existe un docente con ese DNI',
                    icon: 'error',
            })

            }

        })
        .catch((err) => {
                console.error(err)
                Swal.fire({
                    title: 'Error',
                    text: err.response?.data?.message || 'Error - Problemas para agregar al docente -',
                    icon: 'error',
                })
        })
    }

    const resetFormulario = () => {
    setApellido('')
    setNombre('')
    setDni('')
    setEmail('')
    setTitulo('')
    setFechaNac('')
    setDomicilio('')
    setTelefono('')

    setNempleado('')
}
    const capitalizar = (texto) =>
    texto
        .toLowerCase()
        .replace(/\b\w/g, (letra) => letra.toUpperCase());


    return (
        <div>
            <div className="form-register">
                <h1>Nuevo Docente</h1>

                <form onSubmit={guardarDocente}>
                    <label htmlFor="apellido">Apellido</label>
                    <div className='boxinput'>
                        <input
                            type="text"
                            id="apellido"
                            className="controls"
                            placeholder="Apellido"
                            value={apellido}
                            onChange={(e) => setApellido(e.target.value)}
                            required
                        />
                    </div>

                    <label htmlFor="nombre">Nombre</label>
                    <div className='boxinput'>
                        <input
                            type="text"
                            id="nombre"
                            className="controls"
                            placeholder="Nombre"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            required
                        />
                    </div>

                    <label htmlFor="dni">DNI</label>
                    <div className='boxinput'>
                        <input
                            type="text"
                            id="dni"
                            className="controls"
                            placeholder="DNI"
                            value={dni}
                            onChange={(e) => setDni(e.target.value)}
                            required
                        />
                    </div>
                    
                    <label htmlFor="nempleado">Número Empleado</label>
                    <div className='boxinput'>
                        <input
                            type="text"
                            id="nempleado"
                            className="controls"
                            placeholder="N° Empleado"
                            value={nempleado}
                            onChange={(e) => setNempleado(e.target.value)}
                            required
                        />
                    </div>

                    <label htmlFor="email">Email</label>
                    <div className='boxinput'>
                        <input
                            type="email"
                            id="email"
                            className="controls"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <label htmlFor="titulo">Título</label>
                    <div className='boxinput'>
                        <input
                            type="text"
                            id="titulo"
                            className="controls"
                            placeholder="Título profesional"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                        />
                    </div>

                    <label htmlFor="fechaNac">Fecha de Nacimiento</label>
                    <div className='boxinput'>
                        <input
                            type="date"
                            id="fechaNac"
                            className="controls"
                            value={fechaNac}
                            onChange={(e) => setFechaNac(e.target.value)}
                        />
                    </div>

                    <label htmlFor="domicilio">Domicilio</label>
                    <div className='boxinput'>
                        <input
                            type="text"
                            id="domicilio"
                            className="controls"
                            placeholder="Domicilio"
                            value={domicilio}
                            onChange={(e) => setDomicilio(e.target.value)}
                        />
                    </div>

                    <label htmlFor="telefono">Teléfono</label>
                    <div className='boxinput'>
                        <input
                            type="text"
                            id="telefono"
                            className="controls"
                            placeholder="Teléfono"
                            value={telefono}
                            onChange={(e) => setTelefono(e.target.value)}
                        />
                    </div>
                    <ReCAPTCHA
                    sitekey="6Lebr5QrAAAAAOEPzc0JfyJ14XPBTa0gDvvpNFqy" // reemplazá con la real de Google
                    onChange={(token) => setCaptchaToken(token)}
                    />

                    <div>
                    <input className="botons" type="submit" value="Registrar" />
                    </div>

                </form>

                <Link to={'/'} className="botons">Volver</Link>
            </div>
        </div>
    )
}

export default AgregarDocente
